<template>
  <div>
    <div class="box online_bg">
      <div class="wrap w1200 onsite_b">
        <!--右侧-->
        <div class="task_kaoshi_list_ok">
          <dl>
            <dt>邮箱激活</dt>
            <dd class="pay_ok" v-if="result == 'Success'">
              <img src="@/assets/images/pay_ok_icon.png" /><br>邮箱激活成功
            </dd>
            <dd class="pay_ok" v-if="result == 'Error'">
              <img src="@/assets/images/pay_ok_sb.png" /><br>邮箱激活失败
            </dd>
          </dl>
        </div>
        <!--/右侧-->
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>
<script>
  import utils from '@/utils'
  export default {
    components: { },
    data () {
      return {
        params_retrieved: {},
        result: ''
      }
    },
    created () {
      this.params_retrieved.mail = decodeURIComponent(utils.getQueryString('mail')) || ''
      this.params_retrieved.code = decodeURIComponent(utils.getQueryString('code')) || ''
    },
    mounted () {
      this.getResult()
    },
    computed: {
    },
    methods: {
      getResult () {
        this.$api.get(this.$global.bylBaseCenterPath, '/register/validate-email', this.params_retrieved, r => {
          if (r.data) {
            this.result = r.data.result
          }
        })
      }
    }
  }
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/page/modules/email/result.vue